import { BreakpointState } from '@angular/cdk/layout';

export enum CustomBreakpoint {
    SMALL = 0,
    MEDIUM = 1,
    LARGE = 2,
    X_LARGE = 3,
}

export const breakpoints = {
    mq1: '768px',
    mq2: '1023px',
    mq3: '1399px',
    mq4: '1400px',
};

const minWidthQuery = (breakpoint: string) => `(min-width: ${breakpoint})`;
const maxWidthQuery = (breakpoint: string) => `(max-width: ${breakpoint})`;

export const mediaQueries = {
    mq1: maxWidthQuery(breakpoints.mq1),
    mq2: maxWidthQuery(breakpoints.mq2),
    mq3: maxWidthQuery(breakpoints.mq3),
    mq4: minWidthQuery(breakpoints.mq4),
};

export const getCustomBreakpoint = (state: BreakpointState) => {
    const bks = state.breakpoints;
    let breakpoint: CustomBreakpoint;
    if (bks[mediaQueries.mq4]) {
        breakpoint = CustomBreakpoint.X_LARGE;
    } else if (bks[mediaQueries.mq1]) {
        breakpoint = CustomBreakpoint.SMALL;
    } else if (bks[mediaQueries.mq2]) {
        breakpoint = CustomBreakpoint.MEDIUM;
    } else if (bks[mediaQueries.mq3]) {
        breakpoint = CustomBreakpoint.LARGE;
    } else {
        breakpoint = CustomBreakpoint.X_LARGE;
    }

    return breakpoint;
};
